import { render, staticRenderFns } from "./SelfieGetReady.vue?vue&type=template&id=60518998"
import script from "./SelfieGetReady.vue?vue&type=script&lang=js"
export * from "./SelfieGetReady.vue?vue&type=script&lang=js"
import style0 from "./SelfieGetReady.vue?vue&type=style&index=0&id=60518998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports